export default "/images/ic_warning_grey.svg?2343c14b43a06cb960fe511294ff1aef";